import React from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Input from "src/components/form/Input";
import DeliveryAddresses from "./DeliveryAddresses";
import ProjectAttachmentsCompact from "./ProjectAttachmentsCompact";

export default function ContactDetails() {
  return (
    <Paper>
      <Box p={2}>
        <Typography fontWeight={500}>Customer Details</Typography>
        <Grid container spacing={1} sx={{ pt: 1.5 }}>
          <Grid size={{ xs: 12, sm: 4 }}>
            <Input name="contactName" label="Contact Name" showNAButton={false} />
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <Input name="contactEmail" label="Contact Email" showNAButton={false} />
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <Input name="contactPhoneNumber" label="Contact Phone Number" showNAButton={false} />
          </Grid>
        </Grid>
        <DeliveryAddresses />
        <ProjectAttachmentsCompact />
      </Box>
    </Paper>
  );
}
